import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BrandMark = () => (
  <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="38" height="38" rx="2" stroke="#f8f5f0" strokeWidth="1.5"/>
    <path d="M8 30 L15 14 L20 24 L25 10 L32 30" stroke="#d97148" strokeWidth="2" strokeLinecap="square" strokeLinejoin="miter" fill="none"/>
    <circle cx="32" cy="10" r="2.5" fill="#d97148"/>
  </svg>
);

export default function Footer() {
  const { t, i18n } = useTranslation();
  const { lang = 'ar' } = useParams();
  const p = (path) => `/${lang}${path}`;

  const legalLines = t('footer.legalLines', { returnObjects: true }) || [];

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    if (window.location.pathname === `/${lang}` || window.location.pathname === `/${lang}/`) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = `/${lang}#${id}`;
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-col">
            <div className="footer-brand">
              <BrandMark />
              <span>Argenergia</span>
            </div>
            <p className="footer-tagline">{t('footer.tagline')}</p>
          </div>

          <div className="footer-col">
            <h4>{t('footer.sections.platform')}</h4>
            <ul>
              <li><a href={`/${lang}#sectors`} onClick={scrollTo('sectors')}>{t('nav.sectors')}</a></li>
              <li><a href={`/${lang}#analytics`} onClick={scrollTo('analytics')}>{t('nav.analytics')}</a></li>
              <li><a href={`/${lang}#how`} onClick={scrollTo('how')}>{t('nav.insights')}</a></li>
              <li><a href={`/${lang}#contact`} onClick={scrollTo('contact')}>{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t('footer.sections.legal')}</h4>
            <ul>
              <li><NavLink to={p('/privacy-policy')}>{t('nav.privacy')}</NavLink></li>
              <li><NavLink to={p('/cookie-policy')}>{t('nav.cookies')}</NavLink></li>
              <li><NavLink to={p('/terms')}>{t('nav.terms')}</NavLink></li>
              <li><a href="mailto:legal@argenergia.com">legal@argenergia.com</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t('footer.sections.company')}</h4>
            <ul>
              <li><a href="mailto:contacto@argenergia.com">contacto@argenergia.com</a></li>
              <li><a href="mailto:prensa@argenergia.com">prensa@argenergia.com</a></li>
              <li><a href="tel:+541148935200">+54 11 4893-5200</a></li>
              <li>Av. Leandro N. Alem 855, Piso 14 · CABA</li>
            </ul>
          </div>
        </div>

        <div className="legal-details">
          <h5>{t('footer.legalTitle')}</h5>
          <ul>
            {Array.isArray(legalLines) && legalLines.map((line, i) => (<li key={i}>{line}</li>))}
          </ul>
        </div>

        <p className="disclaimer">{t('footer.disclaimer')}</p>

        <div className="copyright">
          <span>© 2019–2026 {t('footer.companyName')} · {t('footer.rights')}</span>
          <span>ARGENERGIA.COM</span>
        </div>
      </div>
    </footer>
  );
}
